class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.cookieName = `Minimog:newsletter-popup-${this.id}`;
    this.cookie = getCookie(this.cookieName);
    this.delay = parseInt(this.dataset.delay) * 1000 || 5000;

    this.modelWrapper = this.querySelector(".m-newsletter-popup");
    this.modal = this.querySelector(".m-modal");
    this.modalContent = this.modal.querySelector(".m-modal--content");
    this.closeButton = this.querySelector("[data-newsletter-popup-close]");
    this.content = this.querySelector("[data-newsletter-popup-content]");
    this.successContent = this.querySelector("[data-newsletter-popup-success]");
    this.copyButton = this.querySelector("[data-newsletter-popup-copy]");
    this.copyText = this.querySelector("[data-newsletter-popup-copy-text]");
    this.discountCode = this.querySelector("[data-newsletter-popup-code]");

    console.log(`this.cookie: `, this.cookie);
    // Check if popup should show
    if (this.cookie === "" && this.dataset.enable === "true") {
      if (Shopify && Shopify.designMode) return;
      
      // Hide popup if URL contains 'account/subscribe'
      if (window.location.href.includes('account/subscribe')) {
        return;
      }
      
      this.init();
    }
  }

  connectedCallback() {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => this.closePopup());
    }

    if (this.copyButton) {
      this.copyButton.addEventListener("click", () => this.copyDiscountCode());
    }

    // Close on overlay click
    this.modal.addEventListener("click", (e) => {
      if (e.target === this.modal) {
        this.closePopup();
      }
    });

    // Handle form submission
    this.handleFormSubmission();

    // Handle external triggers (from cart drawer, etc.)
    this.handleExternalTriggers();
  }

  init() {
    // Show popup after delay
    setTimeout(() => {
      this.openPopup();
    }, this.delay);
  }

  openPopup() {
    this.style.display = "block";
    this.modal.classList.add("m-open-modal");
    this.modal.style.setProperty("--m-opacity", "1");
    document.documentElement.classList.add("prevent-scroll");
  }

  closePopup() {
    this.style.display = "none";
    this.modal.classList.remove("m-open-modal");
    this.modal.style.setProperty("--m-opacity", "0");
    document.documentElement.classList.remove("prevent-scroll");
    
    // Set cookie to prevent showing again this session
    setCookie(this.cookieName, "shown", 1);
  }

  handleFormSubmission() {
    const form = this.querySelector("form");
    if (!form) return;

    form.addEventListener("submit", (e) => {
      // Let the form submit normally first
      setTimeout(() => {
        // Check if form was successful
        const successMessage = this.querySelector(".notification.show.success");
        if (successMessage) {
          this.showSuccessState();
        }
      }, 100);
    });
  }

  handleExternalTriggers() {
    // Listen for clicks on newsletter popup trigger buttons
    document.addEventListener("click", (e) => {
      if (e.target.matches("[data-newsletter-popup-trigger]")) {
        e.preventDefault();
        this.openPopup();
      }
    });
  }

  showSuccessState() {
    this.content.classList.add("m:hidden");
    this.successContent.classList.remove("m:hidden");
    
    // Set cookie to prevent showing again
    setCookie(this.cookieName, "subscribed", 30); // 30 days
  }

  async copyDiscountCode() {
    const code = this.discountCode.textContent.trim();
    
    try {
      await navigator.clipboard.writeText(code);
      this.copyText.textContent = "Copied!";
      this.copyButton.classList.add("copied");
      
      setTimeout(() => {
        this.copyText.textContent = "Copy";
        this.copyButton.classList.remove("copied");
      }, 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      
      this.copyText.textContent = "Copied!";
      this.copyButton.classList.add("copied");
      
      setTimeout(() => {
        this.copyText.textContent = "Copy";
        this.copyButton.classList.remove("copied");
      }, 2000);
    }
  }
}

// Helper functions (reuse from age-verifier.js)
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return "";
}

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

customElements.define("m-newsletter-popup", NewsletterPopup);
